let React               = require("react");

let ContentServerClient = require("../../ContentServerClient.js");
let HubsUtil            = require("../../util/HubsUtil.js");
let Avatar              = require("../Avatar.jsx");
let Dropdown            = require("../buttons/generic/Dropdown.jsx");
let LoadingPlaceholder            = require("../cards/LoadingPlaceholder.jsx");
let ApplicationContext  = require("../../config/ApplicationContext.js");
let Utilities           = require("../../util/Utilities.js");

class CoverHub extends React.Component {

    constructor(){
        super();
        this.state = {
            manageMembersModalTriggered: false
        };

        this.callOpen = this.callOpen.bind(this);
        this.onHubSelected = this.onHubSelected.bind(this);
    }

    onHubSelected(id, name, region){
        if(region){
            ApplicationContext.setCurrentRegion(region);
            Utilities.setCookie(`lastHubRegion=${region}`);
        }
        let encodedName = encodeURIComponent(name);
        this.props.history.push(`/hubs/${id}-${encodedName}/libraries`);
    }

    getSelect(allHubs){
        let { currentHub, allowedNumberOfHubs, currentNumberOfHubs, onOpen, typeUser } = this.props;

        // Only surface the region next to Owner/Member when folders span more than
        // one region; a single-region user sees the unchanged Owner/Member label.
        let showRegion = new Set(allHubs.map(hub => hub.region).filter(Boolean)).size > 1;

        let elements = allHubs.map((hub) => {
            let role = hub.deleted ? "Deleted" : (HubsUtil.isOwner(hub) ? "Owner" : "Member");
            return {
                name: hub.name,
                tootip: hub.name,
                selected: (currentHub)? currentHub.id === hub.id :  false,
                className: hub.deleted ? "--removed": "",
                onClick: (() => this.onHubSelected(hub.id, hub.name, hub.region)),
                badge: <React.Fragment>
                        <span className="typeUser">{role}</span>
                        { showRegion && hub.region && <span className="hubRegion">{hub.region.toUpperCase()}</span> }
                       </React.Fragment>
            };
        });

        let modal = "create";
        if(typeUser === "free" && currentNumberOfHubs >= allowedNumberOfHubs){
            modal = "subscribe";
        }

        let options = [...elements, {name: "Create New", onClick: () => onOpen(modal)}]

        return <Dropdown name={`Change ${hubAlias}`} options={options}/>
    }

    formatMembers(members){
        return members.reduce((accum, {id, avatar}, index) => {
                                if(index < 3){
                                    return [...accum, <Avatar key={id} url={avatar}/>];
                                }else if(members.length === (index + 1)){
                                    return [...accum, <Avatar key={id} type="text" letters={`+${members.length-3}`} style="numberMembers" onClick={() => this.props.onOpen("manage")}/>];
                                } return accum;
                            }, []);
    }

    callOpen(isOwner) {
        if(isOwner){
            this.props.onOpen("manage")
        }else{
            this.props.onOpen("manage", {isView: true})
        }
    }

    sortElements(data){
        return [...data].sort((x,y) => x.name.localeCompare(y.name))
    }

    // Build the dropdown list grouped by region with the home/US region first.
    // All non-deleted folders come first (region-grouped, owners then members),
    // followed by all soft-deleted folders (same region order). e.g. for two
    // regions: US, IND, then US-deleted, IND-deleted.
    buildOrderedHubs(myHubs, memberHubs, trashHubs){
        let homeRegion = ApplicationContext.getHomeRegion();
        let all = [...myHubs, ...memberHubs, ...trashHubs];

        let regionIds = [...new Set(all.map(h => h.region))];
        regionIds.sort((a, b) => a === homeRegion ? -1 : b === homeRegion ? 1 : String(a).localeCompare(String(b)));

        let byRegion = (list, rid) => this.sortElements(list.filter(h => h.region === rid));

        // Non-deleted: owners then members, per region (US first).
        let active = [];
        regionIds.forEach(rid => {
            active = active.concat(byRegion(myHubs, rid)).concat(byRegion(memberHubs, rid));
        });

        // Soft-deleted: after everything else, same region order.
        let deleted = [];
        regionIds.forEach(rid => {
            deleted = deleted.concat(byRegion(trashHubs, rid));
        });

        return active.concat(deleted);
    }

    render() {
        let { loadingHubName,
            currentHub,
            currentHubMembers,
            myHubs,
            memberHubs,
            trashHubs,
            errorListHubs,
            countsByRegion,
            onOpen,
            location } = this.props;

        let isOwner = false;
        let isDeleted = false;

        let allHubs = null;
        if(myHubs  && memberHubs && trashHubs){
            allHubs = this.buildOrderedHubs(myHubs, memberHubs, trashHubs);
        }

        if(currentHub){
            isOwner = HubsUtil.isOwner(currentHub);
            isDeleted = currentHub.deleted;
        }

        let doneLoading = (allHubs && currentHubMembers);
        if ( doneLoading && location.search === "?manageMembers=true" && !this.state.manageMembersModalCalled) {
            this.callOpen(isOwner);
            this.setState({ manageMembersModalCalled: true });
        }

        const totalCountsByRegion = Object.values(countsByRegion || {}).reduce(
          (acc, r) => {
              acc.allowedNumberOfHubs += r.allowedNumberOfHubs;
              acc.currentNumberOfHubs += r.currentNumberOfHubs;
              return acc;
          },
          { allowedNumberOfHubs: 0, currentNumberOfHubs: 0 }
        );

        const OptionsHub = () => {
            if(!allHubs){
                return null
            }else if(allHubs.length >= 2){
                return this.getSelect(allHubs, isOwner);
            }else{
                return <button className="button" onClick={() => onOpen(totalCountsByRegion.currentNumberOfHubs >= totalCountsByRegion.allowedNumberOfHubs ? "subscribe": "create")}>New {fullHubAlias}</button>
            }
        }

        return  <section className="coverHub">
                    <div className="container">
                        <div className="coverHub__options">
                            <div className="coverHub__options__settings">
                                { currentHub &&
                                    <React.Fragment>
                                      <svg width="32px" height="32px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                                          <use xlinkHref='#MFolder' />
                                      </svg>
                                      <h2> {currentHub.name} </h2>
                                    </React.Fragment>
                                }

                                { !currentHub && !errorListHubs && !allHubs &&
                                    <h2> {loadingHubName || "Loading..."} </h2>
                                }

                                { currentHub && isOwner && !isDeleted &&
                                    <div className="coverHub__options__settings__icon" onClick={() => onOpen("update")}></div>
                                }

                                { currentHub &&
                                    <div className="coverHub__options__settings__typeUser">
                                        {!isDeleted && (isOwner ? "Owner": "Member")}
                                        { isDeleted && "Deleted"}
                                    </div>
                                }
                            </div>


                            <div className="coverHub__options__members">
                                <React.Fragment>
                                    {  currentHubMembers && !isDeleted &&
                                        <button className="coverHub__options__members__manage button" onClick={()=>this.callOpen(isOwner)}>
                                                {isOwner ? "Manage Members": "View Members"}
                                        </button>
                                    }
                                    { currentHubMembers &&
                                        <div className="coverHub__options__members__avatars">
                                            <Avatar url={currentHub.owner.avatar}/>
                                            {this.formatMembers(currentHubMembers)}
                                        </div>
                                    }
                                </React.Fragment>

                            </div>

                        </div>

                        <div className="coverHub__new">
                            { allHubs &&
                                <OptionsHub/>
                            }
                            { !allHubs &&
                                <LoadingPlaceholder isError={errorListHubs}/>
                            }
                        </div>

                    </div>
                </section>
    }
}

module.exports = CoverHub;
